<main>   
   <div>
      <div class="h1 icon"><i class="bi bi-cone-striped"></i></div>
      <p class="lead text-muted">Er wordt hard gewerkt aan de nieuwe website.</p>
      <p class="lead">Kom binnenkort nog eens terug!</p>
   </div>
</main>